module.exports = __webpack_public_path__ + "img/xsgl.2d1e24ee.png";